import { Component, Input, EventEmitter, Output } from '@angular/core';
import { MobileAppSubpage } from '../mobile-store/mobile.data';
import { Dictionary } from '@ngrx/entity';
import { MobileAppWrapper } from '../mobile.app.wrapper.component';
import { getDefaultProgramTabNames } from 'globals/store/share.data';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../icon/icon.component';
import { mobileAppFeature } from '../mobile-store/mobile.app.era';

@Component({
    selector: 'mobile-app-top-nav',
    template: `
<div class="sub-page smooth" *ngFor ="let sub of subPages" [class.active]="selectedSubpage === sub" (click)="clickSubpage.emit(sub)">
  <icon [icon]="iconMap[sub]"><div class="dot" *ngIf="dottedSubPages.has(sub)"></div></icon>
  <div class="name">{{  tabNames[mobileAppSubpageToTabId[sub]] || names[sub] }}</div>
</div>
`,
    styleUrls: ["./mobile-app-top-nav.scss"],
    standalone: true,
    imports: [CommonModule, IconComponent]
})
export class MobileAppTopNavComponent extends MobileAppWrapper<MobileAppTopNavComponent> {
  tabNames:{ [tId: string]: string } = getDefaultProgramTabNames()

  @Input() iconMap: Dictionary<string>
  @Input() names: Dictionary<string>
  @Input() subPages: MobileAppSubpage[]
  @Input() selectedSubpage: MobileAppSubpage
  @Input() dottedSubPages: Set<MobileAppSubpage> = new Set()
  @Output() clickSubpage: EventEmitter<MobileAppSubpage> = new EventEmitter()

  constructor() {
    super()
    this.subProp(this.store.select(mobileAppFeature.selectTabNames), 'tabNames')
  }

}